module.exports = __webpack_public_path__ + "img/Katya.5568ca5a.jpg";